import { useEffect, useMemo } from 'preact/hooks';
import { serviceOptions } from '../../../functions/serviceOption';
export const useOptions = ({ watch, setValue }) => {
  const { province, provinceId, district, districtId, subDistrict, isCreateNewAddress } = watch();
  console.log('province : ',isCreateNewAddress)
  const provinceOptions = useMemo(() => serviceOptions('PROVINCE', province), [province]);

  const districtOptions = useMemo(
    () => (isCreateNewAddress && provinceId ? serviceOptions('DISTRICT', district) : []),
    [provinceId, district],
  );

  const subDistrictOptions = useMemo(
    () => (isCreateNewAddress && districtId ? serviceOptions('SUBDISTRICT', subDistrict) : []),
    [districtId, subDistrict],
  );

  useEffect(() => {
    if (provinceId) {
      console.log('option provinceId')
      const selectedDistrict = districtOptions[0];
      if (selectedDistrict) {
        setValue('districtId', selectedDistrict.value);
      }
    }
  }, [provinceId, districtOptions, setValue]);

  return {
    provinceOptions,
    districtOptions,
    subDistrictOptions,
  };
};
